import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/VersionSwitch/VersionList.tsx";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { memo, useCallback } from 'react';
import { useStore } from 'effector-react';
import { Positive, LongText, ClockFace, Recovery, ThreeDotsIcon, ScrollBar } from '@gmini/ui-kit';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { getCustomDate, getTimeFromDate, isNotNullableTime, sortByDate } from "../../helpers/versionDateCommon";
import { DateContainer, DateItem, ListContainer, NoVersionsToShow, PublishedLabel, TitleWrap, VersionContainer, VersionContainerWrap, VersionDivider, VersionInfo, VersionTitle, VersionWrap, VersionTitleText, Expand, ExpandWrap, VersionIconWrap, VersionContentWrap, MenuButtonWrapper, MenuButton } from "./VersionList.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var VersionListWrapped = function VersionListWrapped(_ref) {
  var onMenuClick = _ref.onMenuClick,
      currentVersion = _ref.currentVersion,
      dates = _ref.dates,
      fetchVersions = _ref.fetchVersions,
      versions = _ref.versions,
      contextMenu = _ref.contextMenu,
      openVersionHistory = _ref.openVersionHistory,
      anotherListOpened = _ref.anotherListOpened,
      expandModel = _ref.expandModel,
      isPublished = _ref.isPublished,
      ctxMenu = _ref.ctxMenu,
      pendingMapVersionByDates = _ref.pendingMapVersionByDates,
      createPendingVersionByDatesKey = _ref.createPendingVersionByDatesKey;
  var expanded = useStore(expandModel.expanded$, {
    loc: {
      file: _effectorFileName,
      line: 94,
      column: 19
    },
    name: "VersionListWrapped",
    sid: "VersionListWrapped /src/components/VersionSwitch/VersionList.tsx [94, 19]"
  });
  React.useEffect(function () {
    if (!openVersionHistory && !anotherListOpened) {
      expandModel.resetExpanded();
    }
  }, [expandModel, anotherListOpened, openVersionHistory]);
  var setDayExpanded = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(date) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!expanded[date] && !anotherListOpened)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return fetchVersions(date);

            case 3:
              expandModel.setItemExpanded({
                key: date,
                value: !expanded[date]
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [expandModel, expanded, fetchVersions, anotherListOpened]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ScrollBar, {
      children: [anotherListOpened && !(dates !== null && dates !== void 0 && dates.versionDates.length) && /*#__PURE__*/_jsx(NoVersionsToShow, {
        children: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0432\u0435\u0440\u0441\u0438\u0439"
      }), /*#__PURE__*/_jsx(ListContainer, {
        children: dates === null || dates === void 0 ? void 0 : dates.versionDates.sort(sortByDate).map(function (date) {
          var pendingKey = createPendingVersionByDatesKey === null || createPendingVersionByDatesKey === void 0 ? void 0 : createPendingVersionByDatesKey({
            versionDate: date
          });
          var loading = pendingKey ? pendingMapVersionByDates === null || pendingMapVersionByDates === void 0 ? void 0 : pendingMapVersionByDates[pendingKey] : false;
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs(DateItem, {
              expanded: expanded[date] && !loading,
              onClick: function onClick() {
                return setDayExpanded(date);
              },
              "data-test-id": "expandVersionList",
              children: [/*#__PURE__*/_jsx(DateContainer, {
                children: isNotNullableTime(date) ? getCustomDate(date) : 'Более ранние версии'
              }), /*#__PURE__*/_jsx(ExpandWrap, {
                children: loading ? /*#__PURE__*/_jsx(CircularProgress, {
                  size: "16px"
                }) : /*#__PURE__*/_jsx(Expand, {
                  rotated: expanded[date]
                })
              })]
            }, date), /*#__PURE__*/_jsx(VersionContainerWrap, {
              show: expanded[date],
              children: versions && versions[date] && versions[date].map(function (data) {
                var _ctxMenu$item, _ctxMenu$item2, _ctxMenu$item3;

                return /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsxs(VersionWrap, {
                    currentVersion: currentVersion === data.version,
                    showMenuButton: (ctxMenu === null || ctxMenu === void 0 ? void 0 : (_ctxMenu$item = ctxMenu.item) === null || _ctxMenu$item === void 0 ? void 0 : _ctxMenu$item.id) === data.id,
                    hover: (ctxMenu === null || ctxMenu === void 0 ? void 0 : (_ctxMenu$item2 = ctxMenu.item) === null || _ctxMenu$item2 === void 0 ? void 0 : _ctxMenu$item2.id) === data.id,
                    children: [/*#__PURE__*/_jsxs(VersionContainer, {
                      onContextMenu: function onContextMenu(e) {
                        e.preventDefault();
                        onMenuClick({
                          coords: {
                            x: e.clientX,
                            y: e.clientY
                          },
                          item: data
                        });
                      },
                      children: [/*#__PURE__*/_jsx(VersionIconWrap, {
                        color: currentVersion === data.version ? 'primary' : 'default',
                        children: currentVersion === data.version ? /*#__PURE__*/_jsx(ClockFace, {}) : /*#__PURE__*/_jsx(Recovery, {})
                      }), /*#__PURE__*/_jsxs(VersionContentWrap, {
                        children: [/*#__PURE__*/_jsxs(TitleWrap, {
                          children: [/*#__PURE__*/_jsxs(VersionTitle, {
                            children: [/*#__PURE__*/_jsx(VersionTitleText, {
                              actualVersion: currentVersion === data.version,
                              children: data.name ? /*#__PURE__*/_jsx(LongText, {
                                partSize: 20,
                                children: data.name
                              }) : "V00".concat(data.version)
                            }), (isPublished === null || isPublished === void 0 ? void 0 : isPublished(data)) && /*#__PURE__*/_jsxs(PublishedLabel, {
                              actualVersion: currentVersion === data.version,
                              children: [/*#__PURE__*/_jsx(Positive, {
                                color: currentVersion === data.version ? '#00923A' : 'rgba(53, 59, 96, 0.5)',
                                width: "16px",
                                height: "16px"
                              }), "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043E"]
                            })]
                          }), /*#__PURE__*/_jsx(MenuButtonWrapper, {
                            children: /*#__PURE__*/_jsx(MenuButton, {
                              onClick: function onClick(e) {
                                return onMenuClick({
                                  coords: {
                                    x: e.clientX,
                                    y: e.clientY
                                  },
                                  item: data
                                });
                              },
                              size: "small",
                              type: "circle",
                              active: (ctxMenu === null || ctxMenu === void 0 ? void 0 : (_ctxMenu$item3 = ctxMenu.item) === null || _ctxMenu$item3 === void 0 ? void 0 : _ctxMenu$item3.id) === data.id,
                              children: /*#__PURE__*/_jsx(ThreeDotsIcon, {})
                            })
                          })]
                        }), /*#__PURE__*/_jsx(VersionInfo, {
                          children: "\n                            ".concat(data.name ? "V00".concat(data.version) : '', "\n                            ").concat(data.nameOwner || '', "\n                           ").concat(isNotNullableTime(data.createdDate) ? " \u0432: ".concat(getTimeFromDate(data.createdDate)) : '', "   ")
                        })]
                      })]
                    }), /*#__PURE__*/_jsx(VersionDivider, {})]
                  }, data.id)
                });
              })
            })]
          });
        })
      })]
    }), contextMenu && contextMenu]
  });
};

export var VersionList = /*#__PURE__*/memo(VersionListWrapped);
VersionList.displayName = 'VersionList';